<template lang="html">

  <section class="donde-estamos row-center ais animation">

    <div class="right column-center">

      <div class="info-contacto row-end">

        <div class="container -half">
          <h2 class="title -black">{{$t('banner_newsletter.titulo')}}</h2>
          <p class="-direccion">{{$t('banner_newsletter.cuerpo')}}</p>
          <p class="-email">{{$t('banner_newsletter.email')}} <a href="mailto:info@aldonzagourmet.com">info@aldonzagourmet.com</a></p>
               <p class="-telefono"><span>{{$t('banner_newsletter.telefono')}}</span>  <span><a href="tel:+0034967217711">(+34) 967 21 77 11</a></span> <span class="line">-</span> <span><a href="tel:+0034660634959">(+34) 660 634 959</a></span></p>
        </div>

      </div>

      <div class="mapa">
        <mapa></mapa>
      </div>

    </div>

    <div class="left">

      <article class="banner-vive-aldonza row-center plum-border -xl">
        <router-link :to="$t('enlaces.vive_aldonza')" class="enlace-cover"></router-link>
        <router-link :to="$t('enlaces.vive_aldonza')" class="btn">
          <span>{{$t('banners_experiencia.vive_aldonza.titulo')}}</span>
        </router-link>
      </article>

    </div>

  </section>

</template>

<script lang="js">

  import mapa from '@/components/parts/mapa';

  export default  {
    name: 'donde-estamos',
    components :{
      'mapa' : mapa
    },
  }
</script>

<style scoped lang="scss">

  @import "@/assets/css/colors.scss";

  .donde-estamos{
    background: $plum;
  }



  .info-contacto{
    padding: 35px 0;
    text-align: left;
    width: 100%;
    background: url("/static/img/background-banner-donde-estamos-hojas.jpg") center/cover no-repeat;
    transform: translateX(-400px);
    opacity: 0;
    transition: 1s;

    .title{
      font-size: 24px;
      letter-spacing: 3px;
      transform: translateX(-400px);
      opacity: 0;
      transition: 1s;
      transition-delay: .5s;
    }
  }

  .info-contacto p{
    color: $black;
    max-width: 500px;
    text-align: left;
    padding-left: 30px;
    transform: translateX(-400px);
    opacity: 0;
    transition: 1s;
  }

  @for $i from 1 through 10{
    .info-contacto p:nth-child(#{$i}){
      transition-delay: #{$i / 3 + .5}s;
    }
  }

  .mapa{
    width: 100%;
    display: inline-block;
    flex-grow: 2;
    transform: translateX(-100%);
    transition: 1s;
    opacity: 0;
  }



  .donde-estamos{
    width: 100%;
  }

  .donde-estamos > div{
    width: 50%;
  }

  .banner-vive-aldonza{
    height: 100%;
    opacity: 0;
    transition: 2s;
    transition-delay: 2s;
    z-index: 3;
    position: relative;
  }

  .launched{
    .banner-vive-aldonza{
      opacity: 1;
    }
    .info-contacto,
    .info-contacto p,
    .info-contacto .title{
      transform: translateX(0);
      opacity: 1;
    }

    .mapa{
     transform: translateX(0);
     opacity: 1;
   }
 }

 @media screen and (max-width:1023px){

  .donde-estamos > div{
    width: 100%;
  }

  .banner-vive-aldonza{
    height: 100vw;
  }

}



</style>



// WEBPACK FOOTER //
// src/components/parts/donde-estamos.vue